<template>
    <main-header />
    <div class="science-page">
        <div class="content-container">
            <h1 class="page-title">THE SCIENCE BEHIND MY OXYTOCIN</h1>
            
            <div class="info-block">
                <p class="highlight-text">
                    Oxytocin, as a neuromodulator & neurotransmitter, modulates bonding, trust and affection
                </p>
                <div class="list-items">
                    <div class="item">
                        <span class="number">1)</span> friendship<sup class="sup">(1), (2)</sup>
                    </div>
                    <div class="item">
                        <span class="number">2)</span> human-pet interactions<sup class="sup">(3),(4),(5),(6)</sup>
                    </div>
                </div>
                <p class="highlight-text">
                    with oxytocin levels rising mutually as a bidirectional bonding mechanism
                </p>
            </div>

            <div class="bottom-layout">
                <div class="text-side">
                    <p class="sentiment-paragraph">
                        The name ties science to sentiment <br>
                        & communicate the emotional power <br>
                        behind each gift.
                    </p>
                </div>
                <div class="image-side">
                    <div class="chemistry-label">
                        THE<br>CHEMISTRY<br>OF LOVE
                    </div>
                    <img src="/assets/images/About%20Us%20Page/molecule.png" alt="Oxytocin Molecule" class="molecule-img" />
                </div>
            </div>

            <div class="story-section">
                <div class="story-image-container">
                    <img src="/assets/images/About%20Us%20Page/write-your-story.jpg" alt="Write Your Story" class="story-img" />
                </div>
                <div class="story-content">
                    <div class="quote-block">
                        <p class="quote-main">“You are my oxytocin”</p>
                        <p class="quote-sub">is the shorthand for</p>
                        <p class="quote-main">“You make me feel loved”</p>
                    </div>
                    <div class="molecule-decoration">
                        <img src="/assets/images/About%20Us%20Page/molecule.png" alt="" class="molecule-small" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <main-footer />
</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import MainFooter from "@/components/MainFooter.vue";

export default {
    name: "TestPage",
    components: {
        MainHeader,
        MainFooter
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@700&family=Playfair+Display:ital,wght@0,400;0,700;1,400&display=swap');

.science-page {
    background-color: #FFFAF4;
    color: #4E3B31;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding: 40px 20px;
    display: flex;
    justify-content: center;
    min-height: 80vh;
}

.content-container {
    max-width: 1100px;
    width: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.page-title {
    font-family: 'Oswald', sans-serif;
    font-size: 3.5rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #3D281E;
    margin-bottom: 40px;
    letter-spacing: 0.5px;
    line-height: 1;
}

.info-block {
    margin-bottom: 40px;
    max-width: 900px;
}

.highlight-text {
    font-size: 2rem;
    font-weight: 700;
    color: #8C6B5D;
    margin-bottom: 15px;
    line-height: 1.3;
}

.list-items {
    font-size: 2rem;
    font-weight: 700;
    color: #8C6B5D;
    margin-bottom: 15px;
    padding-left: 0;
}

.item {
    margin-bottom: 8px;
}

.sup {
    font-size: 0.6em;
    vertical-align: super;
    margin-left: 5px;
}

.bottom-layout {
    margin-bottom: -50%;
    display: flex;
    flex-direction: column;
    gap: 40px;
    flex: 1;
}

.text-side {
    margin-top: 20px;
}

.sentiment-paragraph {
    font-family: 'Playfair Display', serif;
    font-style: italic;
    font-size: 2rem;
    color: #BFA575;
    line-height: 1.4;
}

.image-side {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    transform: translateY(-50%);
}

.molecule-img {
    width: 100%;
    max-width: 600px;
    height: auto;
    object-fit: contain;
}

    .chemistry-label {
        position: absolute;
        bottom: 45%;
        right: 20%;
        font-family: 'Oswald', sans-serif;
        font-weight: 700;
        color: #BFA575;
        text-align: center;
        line-height: 1.2;
        font-size: 1rem;
        letter-spacing: 1px;
    }

    .story-section {
        margin-top: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }
    
    .story-image-container {
        width: 100%;
        max-width: 350px;
        margin-bottom: 40px;
    }
    
    .story-img {
        width: 100%;
        height: auto;
        display: block;
    }
    
    .story-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 1100px;
    }
    
    .quote-block {
        text-align: center;
        color: #5D4037;
        margin-bottom: 30px;
    }
    
    .quote-main {
        font-family: 'Playfair Display', serif;
        font-weight: 700;
        font-size: 2.5rem;
        margin: 10px 0;
        line-height: 1.2;
        color: #5D4037;
    }
    
    .quote-sub {
        font-family: 'Playfair Display', serif;
        font-weight: 400;
        font-size: 1.8rem;
        margin: 5px 0;
        color: #5D4037;
    }
    
    .molecule-decoration {
        width: 150px;
        margin-top: -30%;
    }
    
    .molecule-small {
        width: 100%;
        height: auto;
    }

    @media (min-width: 900px) {
        .page-title {
            font-size: 5rem;
        }
        
        .highlight-text, .list-items {
            font-size: 2.5rem;
        }
        
        .bottom-layout {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            transform: translateY(-50%);
        }
        
        .text-side {
            width: 45%;
        }
        
        .image-side {
            width: 50%;
            transform: translateY(0%);
        }
        
        .chemistry-label {
            right: 20%;
            bottom: 44%;
            font-size: 1.8rem;
        }

        .story-image-container {
            max-width: 600px;
        }

        .story-content {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: -20%;
        }
        
        .quote-block {
            text-align: left;
            margin-bottom: 0;
            width: 55%;
        }
        
        .quote-main {
            font-size: 3.5rem;
        }
        
        .quote-sub {
            font-size: 2.2rem;
        }
        
        .molecule-decoration {
            width: 40%;
            max-width: 400px;
            margin-top: 0%;
        }
    }
</style>
